<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h3 class="text-center">Thème «{{ currentTheme.name }}» - Liste des personnages</h3>
      </div>
    </div>
  <div class="row">
        <p style="text-align:center">Enregistrement(s) : {{ currentTheme.nbTexts.done + ' / ' + (currentTheme.nbTexts.total) + ' (' + (currentTheme.nbTexts.total - currentTheme.nbTexts.done) + ' restant(s))' }}</p>
  </div>
  <hr>
  <div class="row">
    <div class="col-md-12">
      <router-link tag="button" class="btn btn-info btn-sm" type="button" :to="{ name: 'PersonCreate', params: { id: currentTheme.id } }">Créer un nouveau personnage</router-link>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col-md-12">
      <table class="table table-hover">
          <thead>
              <tr>
                  <th>Nom</th>
                  <th>Genre</th>
                  <th>Enregistrements</th>
                  <th>Utilisateur lié</th>
                  <th>Actions</th>
              </tr>
          </thead>
          <tbody v-if="persons.length">
              <tr v-for="person in persons" :key="person.id">
                  <td v-html="person.name"></td>
                  <td>{{ person.gender == 'MALE' ? "Homme" : "Femme" }}</td>
                  <td class="text-center">{{ person.nbTexts.done + ' / ' + (person.nbTexts.total) + ' (' + (person.nbTexts.total - person.nbTexts.done) + ' restant(s))' }}</td>
                  <td>{{ person.user ? person.user.customUsername : '-' }}</td>
                  <td>
                      <router-link tag="button" class="btn btn-info btn-sm" type="button" :to="{ name: 'PersonDetail', params: { personId: person.id } }">Textes</router-link>
                      <router-link v-if="person.nbTexts.done" tag="button" class="btn btn-info btn-sm" type="button" :to="{ name: 'PersonReview', params: { personId: person.id } }">Review</router-link>
                      <a v-show="person.nbTexts.done" download :href="personSoundExportUrl(person)" class="btn btn-info btn-sm">Export sons</a>
                      <a v-show="person.nbTexts.total" download :href="personTextExportUrl(person)" class="btn btn-info btn-sm">Export textes</a>
                      <router-link tag="button" class="btn btn-info btn-sm" type="button" :to="{ name: 'PersonEdit', params: { themeId: currentTheme.id, personId: person.id } }">Editer</router-link>
                      <button class="btn btn-info btn-sm" type="button" @click="toggleUntoggleVoiceGeneration(person)">Générer les voix</button>
                      <button class="btn btn-info btn-sm" type="button" @click="toggleUntoggleLinkUser(person)">Lier un utilisateur</button>
                      <button class="btn btn-info btn-sm" type="button" @click="toggleUntoggleDelete(person)">Supprimer</button>
                  </td>
              </tr>
          </tbody>
          <tbody v-else>
          <tr>
              <td>
                  Aucun personnage.
              </td>
          </tr>
          </tbody>
      </table>
      <div class="pager"></div>
    </div>
  </div>
  <modal effect="fade" :title="voiceGenerationModalTitle" :value="showVoiceGenerationModal" cancel-text="Annuler" ok-text="Générer" @ok="generateVoices()" @cancel="toggleUntoggleVoiceGeneration()" :backdrop="backdropEnabled">
      <voice-selection v-if="showVoiceGenerationModal" ref="voiceSelection" text="Ceci est un test." :voiceOptions="voiceOptions"></voice-selection>
  </modal>
  <modal effect="fade" :title="linkUserModalTitle" :value="showLinkUserModal" cancel-text="Annuler" ok-text="Lier" @ok="updatePersonUser()" @cancel="toggleUntoggleLinkUser()">
      <div class="form-group" @keyup.enter="updatePersonUser()">
          <vAlert type="warning" v-show="modalPerson.user">{{ "Attention ! Un utilisateur est déjà lié à ce personnage.\nLa liaison d'un nouvel utilisateur enlèvera l'accès au personnage à l'utilisateur actuel" }}</vAlert>
          <label>Mail de l'utilisateur : </label>
          <typeahead
          :placeholder="linkUserPlaceholder"
          v-model="selectedLinkUser.email"
          async-key="data"
          :async="typeaheadSource"
          :template="typeaheadTemplate"
          :on-hit="typeaheadCallback"
          ></typeahead>
      </div>
      <div style="color:red;" v-if="requiredUser">
          Vous devez choisir un utilisateur.
      </div>
  </modal>
  <modal effect="fade" :title="importModalTitle" :value="showImportModal" cancel-text="Annuler" ok-text="Importer" @ok="toggleUntoggleImport()" @cancel="toggleUntoggleImport()">
      <importTextFiles v-if="modalPerson.id" :modal-person="modalPerson" @importSuccess="onImportSuccess"></importTextFiles>
      <div slot="modal-footer"></div>
  </modal>
  <modal effect="fade" :title="deleteModalTitle" :value="showDeleteModal" cancel-text="Annuler" ok-text="Supprimer" @ok="deletePerson()" @cancel="toggleUntoggleDelete()">
      <div v-html="deleteModalText">
      </div>
  </modal>
</div>
</template>


<script>
    import { alert as VAlert, input as BsInput, modal as Modal, typeahead as Typeahead }  from 'vue-strap'
    import ImportTextFiles from 'components/ImportTextFiles'
    import VoiceSelection from 'components/VoiceSelection';

    export default {
        components: {
            Modal,
            BsInput,
            ImportTextFiles,
            Typeahead,
            VAlert,
            VoiceSelection
        },
        computed: {
            currentTheme: function() {
                return this.$store.state.admin.currentTheme;
            },
            persons: function() {
                return this.currentTheme.persons;
            },
            voiceGenerationModalTitle: function()  {
                return "Génération des voix du personnage \"" + this.modalPerson.name + "\"";
            },
            linkUserModalTitle: function()  {
                return "Lier un utilisateur au personnage \"" + this.modalPerson.name + "\"";
            },
            importModalTitle: function()  {
                return "Importer des fichiers pours le personnage \"" + this.modalPerson.name + "\"";
            },
            deleteModalTitle: function()  {
                return "Suppression du personnage \"" + this.modalPerson.name + "\"";
            },
            deleteModalText: function()  {
                return "Confirmez-vous la suppression du personnage \"" + this.modalPerson.name + "\" ?";
            },
            linkUserPlaceholder: function() {
                if (this.modalPerson.user)  {
                    return this.modalPerson.user.email + ' (' + this.modalPerson.user.customUsername + ')';
                }
                return "";
            },
            typeaheadSource: function() {
                return this.$store.state.baseUrl + "/admin/users?token=" + this.$store.state.token + "&hint=";
            }
        },
        methods: {
            generateVoices() {
              let self = this;
              this.$store.dispatch('generateVoicesForPerson', {
                  personId: this.modalPerson.id,
                  textToSpeechData: this.$refs.voiceSelection.voiceOptions,
                  callbacks: {
                      success(personId) {
                          self.$store.commit('VOICE_PRESET_ADDED', Object.assign(self.$refs.voiceSelection.voiceOptions, {id: -1}));
                          self.$store.commit('ALERT_DATA_UPDATED', {
                              text: "La génération des voix du personnage a été faite avec succès.",
                              type: 'success'
                          });
                          self.toggleUntoggleVoiceGeneration();
                      }
              }});
            },
            updatePersonUser()  {
                if (!this.selectedLinkUser.email)  {
                    this.requiredUser = true;
                    return ;
                }

                let successCallback = () => {
                    this.toggleUntoggleLinkUser();
                    this.$store.dispatch('getTheme', {
                        themeId: this.$route.params.themeId, 
                        callbacks: {
                            success: (data) => {
                                this.$store.commit("CURRENT_THEME_UPDATED", data);
                                this.$store.commit('ALERT_DATA_UPDATED', {
                                    text: "La liaison de l'utilisateur avec le personnage a été faite avec succès.",
                                    type: 'success'
                                });
                            }
                        }
                    });
                };
                this.$store.dispatch('linkUserToPerson', {
                    personId: this.modalPerson.id,
                    newUser: this.selectedLinkUser,
                    callbacks: { success: successCallback,
                                 fail: this.toggleUntoggleLinkUser,
                                 error: this.toggleUntoggleLinkUser }
                });
            },
            onImportSuccess() {
                this.toggleUntoggleImport();
                this.$store.dispatch('getTheme', {
                    themeId: this.$route.params.themeId,
                    callbacks: {
                        success: (data) => {
                            this.$store.commit("CURRENT_THEME_UPDATED", data);
                            this.$store.commit('ALERT_DATA_UPDATED', {
                                    text: 'Les fichiers ont été importés avec succès.',
                                    type: 'success'
                            });
                        }
                    }
                });
            },
            personSoundExportUrl(person)    {
                return this.$store.state.baseUrl + '/admin/person/' + person.id + '/sound-export?token=' + this.$store.state.token;
            },
            personTextExportUrl(person)    {
                return this.$store.state.baseUrl + '/admin/person/' + person.id + '/text-export?token=' + this.$store.state.token;
            },
            toggleUntoggleVoiceGeneration(person)  {
                if (person)  {
                    this.modalPerson = person;
                    this.voiceOptions = person.voiceOptions ? Object.assign({}, person.voiceOptions) : {
                        voiceName: 'fr-FR-Wavenet-A',
                        pitch: 0.00,
                        speakingRate: 1.00
                    };
                }
                this.showVoiceGenerationModal = !this.showVoiceGenerationModal;
            },
            toggleUntoggleLinkUser(person)  {
                this.requiredUser = false;
                if (person)  {
                    this.selectedLinkUser = {email: null};
                    this.modalPerson = person;
                }
                this.showLinkUserModal = !this.showLinkUserModal;
            },
            toggleUntoggleImport(person)  {
                if (person)  {
                    this.modalPerson = person;
                }
                this.showImportModal = !this.showImportModal;
            },
            toggleUntoggleDelete(person)  {
                if (person)  {
                    this.modalPerson = person;
                }
                this.showDeleteModal = !this.showDeleteModal;
            },
            deletePerson() {
                let successCallback = () => {
                    this.toggleUntoggleDelete();
                    this.$store.dispatch('getTheme', {
                        themeId: this.$route.params.themeId,
                        callbacks: {
                            success: (data) => {
                                this.$store.commit("CURRENT_THEME_UPDATED", data);
                                this.$store.commit('ALERT_DATA_UPDATED', {
                                        text: 'Le personnage «' + this.modalPerson.name + '» a été supprimé avec succès.',
                                        type: 'success'
                                });
                            }
                        }
                    });
                };
                this.$store.dispatch('deletePerson', {
                    personToDelete: this.modalPerson,
                    callbacks: {
                        success: successCallback,
                        fail: this.toggleUntoggleDelete,
                        error: this.toggleUntoggleDelete
                    }
                });
            },
            typeaheadCallback(item) {
                if (item)   {
                    this.selectedLinkUser = item;
                    return item.email;
                }
                return this.selectedLinkUser.email;
            },
            formatDate(date)  {
                let d = new Date(date);
                return d.getDate().toString().padStart(2, "0") + '/' + (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getFullYear() + ' - ' + d.getHours() + ':' + d.getMinutes().toString().padStart(2, "0");
            }
        },
        data: function()  {
            return {
                showVoiceGenerationModal: false,
                showLinkUserModal: false,
                showImportModal: false,
                showDeleteModal: false,
                cancelTextModal: "Annuler",
                modalPerson: {
                    id: 0,
                    name: ""
                },
                backdropEnabled: false,
                typeaheadTemplate: "{{ item.email + ' (' + item.customUsername + ')' }}",
                selectedLinkUser: {
                    email: null
                },
                requiredUser: false,
                voiceOptions: {}
            };
        },
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                text: 'Retour aux thèmes',
                pathData: {
                    name: "ThemeList"
                }
            });
        }
    };
</script>

<style>


</style>
